"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const picker_1 = require("@react-native-picker/picker");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const styles_1 = __importDefault(require("../../styles/styles"));
const selectStyles_1 = __importDefault(require("./selectStyles"));
const useWebDesktopDesign_1 = __importDefault(require("../../hooks/useWebDesktopDesign"));
const colors_1 = __importDefault(require("../../styles/colors"));
const themes_1 = __importDefault(require("../../styles/themes"));
const defaultProps = {
    setValueFormik: undefined,
    style: [],
    searchable: false,
    onSearch: undefined,
};
const Select = ({ choices, setValue, value, setValueFormik, style, searchable, onSearch, }) => {
    const isDesktop = useWebDesktopDesign_1.default();
    const action = (itemValue) => setValue(itemValue);
    const [query, setQuery] = react_1.useState('');
    const [filteredChoices, setFilteredChoices] = react_1.useState(choices);
    const [displaySearchBar, setDisplaySearchBar] = react_1.useState(false);
    react_1.useEffect(() => {
        // Always ensure we are using the updated state of choices.
        setFilteredChoices(choices);
    }, [choices]);
    const handleSearchInputChange = (input) => {
        setQuery(input);
        // if custom search is provided, lets use that one instead.
        if (onSearch) {
            onSearch(input);
            return;
        }
        // This implies we are performing a local filter
        const filtered = choices.filter((choice) => choice.label.toLowerCase().includes(input.toLowerCase()));
        setFilteredChoices(filtered);
        // If the filtered list is not empty, update the selected value in the Picker with the first item on the select field.
        const selectedValue = filtered.length > 0 ? String(filtered[0].value) : undefined;
        if (setValueFormik) {
            setValueFormik(selectedValue);
        }
        else {
            setValue(selectedValue);
        }
    };
    return (react_1.default.createElement(react_native_1.View, { style: [
            isDesktop ? styles_1.default.flexDirectionRow : styles_1.default.flexDirectionColumn,
            styles_1.default.alignItemsCenter,
            styles_1.default.flexOne,
        ] },
        react_1.default.createElement(react_native_1.View, { style: [
                styles_1.default.flexDirectionRow,
                styles_1.default.alignItemsCenter,
                !isDesktop && selectStyles_1.default.mobilePickerContainerStyle,
                styles_1.default.fullWidth,
            ] },
            react_1.default.createElement(picker_1.Picker, { selectedValue: value, onValueChange: setValueFormik || action, style: [styles_1.default.selectInput, selectStyles_1.default.select, style], itemStyle: [styles_1.default.textTitle] }, filteredChoices.map((item) => (react_1.default.createElement(picker_1.Picker.Item, { label: item.label, key: item.label, value: item.value })))),
            searchable && (react_1.default.createElement(react_native_paper_1.IconButton, { style: [selectStyles_1.default.searchButton], iconColor: colors_1.default.WHITE, icon: "magnify", size: 20, onPress: () => setDisplaySearchBar(!displaySearchBar), containerColor: colors_1.default.BLUE })),
            searchable && displaySearchBar && (react_1.default.createElement(react_native_paper_1.TextInput, { label: "Search", value: query, style: [
                    styles_1.default.textInput,
                    styles_1.default.marginTen,
                    selectStyles_1.default.searchBar,
                    selectStyles_1.default.marginLeftNegativeSeven,
                    { minWidth: '50%', width: '50%' },
                ], onChangeText: handleSearchInputChange, theme: themes_1.default.textInput })))));
};
Select.defaultProps = defaultProps;
exports.default = Select;
